<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        {{title}}
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right" @click="toHome()">
        <van-icon name="manager" size="21" />
      </div>
    </div>
    <div class="padding content">
      <van-loading size="24px" v-show="showL" style="text-align:center">加载中...</van-loading>
      <div class="info-tit" v-show="!showL">{{info.title}}</div>
      <!-- <div class="info-time">{{info.create_time | formatDate}}</div> -->
      <form>
      <div class="infos" v-html="content"></div>
      </form>
    </div>
    <div class="apply-shen" v-if="info.has_form==1" @click="toApply()" v-show="showBtn">
      <div class="apply-btn">持证残疾人申请</div>
    </div>
    <div class="apply-shen" v-if="info.has_form==1" v-show="!showBtn">
      <div class="apply-btn apply-btn2">持证残疾人申请</div>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button :beforeClose="beforeClose">
      <div style="margin:1.5rem 0">您确定要申请吗？</div>
    </van-dialog>
  </div>
</template>
<script>
import { Icon, Field, Toast, Dialog, Loading } from "vant";
import { wantContent, tokenStatus, userApplyAdd } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
import $ from "jquery";
import timeVue from "./time.vue";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      info: [],
      type: "",
      content: "",
      token: "",
      show: false,
      title: "",
      showL: true,
      showBtn: true,
      tokenW:""
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    let id = this.$route.query.id;
    let title = this.$route.query.title;
    this.title = title;
    this.getIntro(id);
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome() {
      this.$router.push("/mine");
    },
    getIntro(id) {
      wantContent({ id: id }).then((res) => {
        this.info = res.data;
        if (res.data.content == null) {
          this.content = "暂无介绍";
        } else {
          this.content = this.html2Escape(res.data.content);
          // var con = this.html2Escape(res.data.content);
          // var serverSrc = "http://cjr.cn";
          // var srcReg = /src=([\'\"]?([^\'\"]*)[\'\"]?)/gi;
          // con = con.replace(srcReg, "src='" + serverSrc + "$2" + "'");
          // this.content = con;
        }
        this.showL = false;
      });
    },
    html2Escape(str) {
      var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    toApply() {
      this.showBtn = false;
      var token = localStorage.getItem("tokenC");
      var tokenW = localStorage.getItem("tokenY")
      this.tokenW = tokenW
      if (token) {
        this.token = token;
        this.getTokenS();
      } else {
        this.$router.push("/login");
      }
    },
    getTokenS() {
      tokenStatus({ token: this.token }).then((res) => {
        if (res.status == 1) {
          this.show = true;
        } else {
          this.$router.push("/login");
        }
      });
    },
    serializeObject(){

    },
    beforeClose(action, done) {
      if (action === "confirm") {
        var select = $("select")
          .find("option:selected")
          .text();
        var textarea = $("textarea").val();
        // console.log(textarea)
        // var parm = {
        //   menu_id: this.info.id,
        //   token: this.token,
        //   select: select,
        //   textarea: textarea,
        // };
        var arr = $('form').serializeArray()
         var parm=new Object();
         $.each(arr,function(index,param){
            if(!(param.name in parm)){
                parm[param.name]=param.value;
            }
        });
        parm.menu_id = this.info.id
        parm.token = this.token
        parm.wtoken = this.tokenW
        userApplyAdd(parm).then((res) => {
          if (res.status == 1) {
            setTimeout(done);
            this.$router.push({
              path: "/successful",
              query: {
                type: 1,
              },
            });
          } else {
            Toast(res.message);
          }
        });
      } else {
        this.showBtn = true;
        done();
      }
    },
  },
};
</script>
<style scoped>
.info-tit {
  font-weight: bold;
}
.content {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 1rem; */
  /* margin-top: 10%; */
  text-align: left;
}

.info-tit {
  font-size: 1rem;
  margin: 1rem 0;
  border-bottom: solid 1px gainsboro;
  padding-bottom: 1rem;
}
.info-time {
  font-size: 0.9rem;
  color: gray;
}
.info-time span {
  color: #72b550;
  margin-right: 1rem;
}
.infos {
  font-size: 1rem;
}
.info-img {
  text-align: center;
  margin: 1rem 0;
}
.info-img img {
  width: 80%;
  margin: 0 auto;
}
.list {
  border-bottom: solid 1px gainsboro;
  color: gray;
  padding: 1rem 0;
}
.apply-shen {
  width: 90%;
  margin: 0 auto;
  padding: 1rem 0 2rem;
  border-top: solid 1px gainsboro;
}
.apply-btn {
  display: block;
  border-radius: 12px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-weight: 500;
  width: 100%;
  margin: 0 auto;
  background-color: #74ba50;
}
.apply-btn2 {
  background-color: #9e9e9e;
}
</style>


// WEBPACK FOOTER //
// src/page/wantInfo.vue